// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ij-3";
export var downloadButton = "_ij-4";
export var fileContainer = "_ij-9 _ij-7";
export var fileContainerBase = "_ij-7";
export var fileContainerFixedHeight = "_ij-8 _ij-7";
export var fileInfo = "_ij-5";
export var fileInfoWidthRestricted = "_ij-6";
export var fileType = "_ij-1";
export var fileTypeName = "_ij-2";
export var image = "_ij-0";
export var link = "_ij-b";
export var overflowEllipsis = "_ij-a";